<template>
  <ErrorPage :error="error" />
</template>

<script>
import { logToConsole } from '../helpers/common'
import ErrorPage from '@/components/NewDesign/Page/Error/ErrorPage.vue'
import ErrorPageMixin from '@/components/NewDesign/Page/Error/mixins/ErrorPageMixin'

export default {
  components: { ErrorPage },
  mixins: [ErrorPageMixin],
  layout: (ctx) => {
    if (ctx.$device.isDesktop) {
      return 'primary-desktop'
    } else {
      return 'primary-mobile'
    }
  },
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  head() {
    return {
      title: this.errorData?.pageTitle,
    }
  },
  mounted() {
    logToConsole(this.error.message)
  },
}
</script>
